import { FormField, FormFieldType } from '@enroller/admissions-components';
import { Grid2 } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { TitledSection } from '../../../layout/TitledSection';
import { HousingFormValues } from './HousingFormValues';
import { API_FIELDS_APPLICATION as APPLICATION } from '@enroller/admissions-components';
import { HOUSING_PAGE_SECTIONS } from './HousingFormValues';

const kidsAttitudeOptions = [
  { label: 'I like them very much', value: 'I like them very much' },
  { label: 'I like them', value: 'I like them' },
  { label: 'I have no experience with this age group', value: 'I have no experience with this age group' },
  { label: 'I am not entirely comfortable with them', value: 'I am not entirely comfortable with them' },
];

const attendReligiousServicesOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'Sometimes', value: 'Sometimes' },
  { label: 'Seldom', value: 'Seldom' },
  { label: 'Never', value: 'Never' },
];

const participateReligiousServicesOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'Sometimes', value: 'Sometimes' },
  { label: 'No', value: 'No' },
  {
    label: 'I prefer to attend services religious of my own religious affiliation',
    value: 'I prefer to attend services religious of my own religious affiliation',
  },
];

const religiousPreferenceOptions = [
  { label: 'Buddhist', value: 'Buddhist' },
  { label: 'Christian', value: 'Christian' },
  { label: 'Catholic', value: 'Catholic' },
  { label: 'Jewish', value: 'Jewish' },
  { label: 'Muslim', value: 'Muslim' },
  { label: 'Protestant', value: 'Protestant' },
  { label: 'None', value: 'None' },
  { label: 'Other', value: 'Other' },
];

const smokingPolicyOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'Yes, but only if they smoke outdoors', value: 'Yes, but only if they smoke outdoors' },
  { label: 'No', value: 'No' },
];

export const HousingSection = () => {
  const { control } = useFormContext<HousingFormValues>();
  const watchReligiousPreference = useWatch({
    control,
    name: `${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.religiousPreference}.value`,
  });

  return (
    <TitledSection title="Housing">
      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.youngChildrenFeelings}`}
          type={FormFieldType.Radio}
          options={kidsAttitudeOptions}
          label="How do you feel about children five (5) years old and younger?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.attendReligiousServices}`}
          type={FormFieldType.Radio}
          options={attendReligiousServicesOptions}
          label="Do you attend religious services?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.willAttendWithHostFamily}`}
          type={FormFieldType.Radio}
          options={participateReligiousServicesOptions}
          label="Would you participate in religious services with a family who would like you to do so?"
        />
      </Grid2>

      <Grid2 container spacing={4} size={12}>
        <Grid2 size={6}>
          <FormField
            control={control}
            name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.religiousPreference}.value`}
            type={FormFieldType.Dropdown}
            options={religiousPreferenceOptions}
            label="What is your religious preference? If none, please choose none."
          />
        </Grid2>
        <Grid2 size={6}>
          <FormField
            control={control}
            type={FormFieldType.Text}
            label="If Other, please explain"
            name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.religiousPreference}.other`}
            disabled={watchReligiousPreference !== 'Other'}
          />
        </Grid2>
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.understandNoSmoking}`}
          type={FormFieldType.Checkbox}
          label="Do you understand that students are not permitted to smoke while participating on the program?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${HOUSING_PAGE_SECTIONS.housing}.${APPLICATION.adjustToSmokers}`}
          type={FormFieldType.Radio}
          options={smokingPolicyOptions}
          label="Can you adjust to a home where others smoke?"
        />
      </Grid2>
    </TitledSection>
  );
};
